// assets/discount-hint.js — einmal global laden, NICHT inline im Section-Markup
(function () {
  const PRODUCT_ID = 15506990825847;
  let cartQty = 0;

  async function refreshCartQty() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      cartQty = cart.items
        .filter((i) => i.product_id === PRODUCT_ID)
        .reduce((sum, i) => sum + i.quantity, 0);
    } catch (e) {
      /* letzten bekannten Stand behalten */
    }
    render();
  }

  function render() {
    // Hint bei jedem Render neu suchen — überlebt Section-Re-Renders
    const hint = document.querySelector('[id^="Quantity-Discount-Hint-"]');
    if (!hint) return;

    const input =
      hint.closest('.product-form__quantity')?.querySelector('.quantity__input') ||
      document.querySelector('.quantity__input');
    const inputQty = input ? parseInt(input.value, 10) || 0 : 0;
    const total = cartQty + inputQty;

    let msg;
    if (total >= 3) {
      msg = '30% Ersparnis erreicht ✓';
    } else if (total === 2) {
      msg = '+1 Paket = 30% Ersparnis';
    } else {
      msg = '+1 Paket = 25% Ersparnis';
    }
    hint.innerHTML = msg;
    hint.hidden = false;
  }

  // Delegation auf document: überlebt Variantenwechsel & Re-Renders
  document.addEventListener('change', (e) => {
    if (e.target.matches('.quantity__input, variant-selects input, variant-selects select')) {
      render();
    }
  });
  document.addEventListener('input', (e) => {
    if (e.target.matches('.quantity__input')) render();
  });

  // Nach jedem Cart-Update (Add-to-Cart, Drawer-Änderung) Menge neu laden
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCartQty);
  } else {
    // Fallback für ältere Themes ohne globales Pub/Sub
    document.addEventListener('submit', (e) => {
      if (e.target.matches('form[action*="/cart/add"]')) setTimeout(refreshCartQty, 1500);
    });
  }

  refreshCartQty();
})();